module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.modalId
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), (_vm.user) ? _c('div', {
    staticClass: "modal-body row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', [_vm._v("First Name")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.user.firstName))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', [_vm._v("Last name")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.user.lastName))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.user.email))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', [_vm._v("Role")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.userRoleLabel))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    ref: "closeButton",
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("\n          View user\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5eafb4c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/User/ViewUserModal.vue
// module id = 2149
// module chunks = 0